import { Button, Col, Form, Modal, Row } from "react-bootstrap";
// css
import styles from "./ConfirmedAppointment.module.scss";
import { CloseIcon } from "Assets/icons";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { userFullName } from "helpers/common";
import { APPOINTMENT_LIST } from "config/paths";
import { useNavigate } from "react-router-dom";

const ConfirmedAppointmentModal = ({ show, setShow, data, onSuccess }) => {
    const navigate = useNavigate()
    const handlePopup = () => setShow(!show);

    console.log('confirnedData', data)
    // client_id: values?.clientId?.value,
    // guardian_id: values?.parentId,
    // title: values?.title,
    // description: values?.description,
    // additional_notes: values?.additional_notes,
    // appointment_reason: values?.appointment_reason,
    // appointment_type: values?.appointment_type?.value,
    // assessment_services: values?.assessment_services?.map((item) => item?.value),
    // consent_forms: values?.consent_forms?.map((item) => item?.value),
    // clientResources: values?.clientResources,
    // appointment_category: values?.clientType?.value

    // {
    //     "firstname": "",
    //     "clientId": {
    //         "value": 3423,
    //         "label": "ab_child ab_child"
    //     },
    //     "parentId": 3424,
    //     "title": "New Lorem Test",
    //     "description": "New Lorem Test",
    //     "additional_notes": "New Lorem Test",
    //     "parentLastname": "ab_child_parent",
    //     "parentFirstname": "ab_child",
    //     "parentEmail": "ab_child@yopmail.com",
    //     "parentPhone": "4444444444444",
    //     "clientType": {
    //         "value": "home_education",
    //         "label": "Home Education"
    //     },
    //     "appointment_reason": "New Lorem Test",
    //     "appointment_type": {
    //         "label": "Paid",
    //         "value": "paid"
    //     },
    //     "clientResources": "",
    //     "assessment_services": [
    //         {
    //             "label": "Consultation",
    //             "value": 4
    //         },
    //         {
    //             "label": "Multi Team Assessment",
    //             "value": 5
    //         }
    //     ],
    //     "consent_forms": [
    //         {
    //             "value": 13,
    //             "label": "testing form"
    //         },
    //         {
    //             "value": 17,
    //             "label": "testing form home_edu"
    //         }
    //     ],
    //     "consentFormEmail": true,
    //     "consentForms": []
    // }
    return (
        <>
            <Modal
                show={show}
                className={`${styles.AssignChecklist} AssignChecklist appoitment-popup`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                scrollable
                size="md"

            >
                <Modal.Body className={`${styles.modalBody} rounded position-relative`} style={{ background: "#fff" }}>
                    <div className="" style={{ background: "#fff", borderRadius: "50%", padding: "10px", boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px", position: "absolute", top: -24, left: "50%", transform: "translateX(-50%)" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 16 16">
                            <g fill="none" stroke="#009d10" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                                <path d="M14.25 8.75c-.5 2.5-2.385 4.854-5.03 5.38A6.25 6.25 0 0 1 3.373 3.798C5.187 1.8 8.25 1.25 10.75 2.25" />
                                <path d="m5.75 7.75l2.5 2.5l6-6.5" />
                            </g>
                        </svg>
                    </div>
                    <div className="d-flex mt-3 flex-column align-items-center text-center">
                        <h5 className="m-2 fw-bold themeBlue">
                            Appointment request has been created successfully
                        </h5>
                    </div>
                    <hr />

                    <div className="d-flex align-items-center flex-wrap" style={{ columnGap: "10px" }}>
                        <Col style={{ width: "calc(50% - 10px)" }} className="mb-2">
                            <div className="border p-1 rounded-2 text-center">
                                <label className="fw-bold themeBlue">Client:</label>
                                <p className="m-0 text-capitalize themeBlue">{data?.clientId?.label || "--"}</p>
                            </div>
                        </Col>

                        <Col style={{ width: "calc(50% - 5px)" }} className="mb-2">
                            <div className="border p-1 rounded-2 text-center">
                                <label className="fw-bold themeBlue">Title:</label>
                                <p className="m-0 text-capitalize themeBlue">{data?.title || "--"}</p>
                            </div>
                        </Col>

                        <Col md={12} className="mb-2">
                            <div className="border p-1 rounded-2 text-center">
                                <label className="fw-bold themeBlue">Appointment Type:</label><br />
                                <p style={{ background: "transparent" }} className={`${data?.aspanpointment_type?.value == "paid"
                                    ? "yellowStatus"
                                    : "greenStatus"
                                    } m-0`}>
                                    {data?.appointment_type?.value || "--"}
                                </p>
                                {/* <div>
                                    <span
                                        className={`status fw-bold text-capitalize m-0 rounded-pill px-3 py-1 ${data?.appointment_type?.value === "paid" ? "yellowStatus" : "greenStatus"
                                            }`}
                                        style={{ display: "inline-block" }}
                                    >
                                        {data?.appointment_type?.value || "--"}
                                    </span>
                                </div> */}
                            </div>
                        </Col>

                        <Col md={12} className="mb-2">
                            <div className="border p-1 rounded-2 text-center">
                                <label className="fw-bold themeBlue">Description:</label>
                                <p className="m-0 text-capitalize themeBlue">{data?.description || "--"}</p>
                            </div>
                        </Col>

                        <Col md={12} className="mb-2">
                            <div className="border p-1 rounded-2 text-center">
                                <label className="fw-bold themeBlue">Reason:</label>
                                <p className="m-0 text-capitalize themeBlue">{data?.appointment_reason || "--"}</p>
                            </div>
                        </Col>

                        <Col md={12} className="mb-2">
                            <div className="border p-1 rounded-2 text-center">
                                <label className="fw-bold themeBlue">Additional Notes:</label>
                                <p className="m-0 text-capitalize themeBlue">{data?.additional_notes || "--"}</p>
                            </div>
                        </Col>

                        {data?.consentFormEmail && (
                            <Col md={12} className="mb-2">
                                <label className="fw-bold themeBlue">Note:</label>
                                <p className="m-0 themeBlue small">
                                    An email has been sent to the parent with consent forms.
                                </p>
                            </Col>
                        )}
                    </div>

                    <div className="d-flex justify-content-center mt-3">
                        <Button
                            type="button"
                            className="btn text-white commonBtn fw-sbold px-4"
                            onClick={() => navigate(APPOINTMENT_LIST)}
                        >
                            OK
                        </Button>
                    </div>
                </Modal.Body>
            </Modal >

        </>
    );
};

export default ConfirmedAppointmentModal;